<template>
  <div class="bg">
    <div class="logo">
      <img src="../../assets/logoWhite.png" />
    </div>
    <!--form-->
    <form action class="formBox">
      <div class="formTitle">
        <h3>玄鸟外服管理登录系统</h3>
      </div>
      <div class="userName">
        <input type="text" v-model="userName" placeholder="请输入账号" />
        <span class="mark-error">请输入账号</span>
      </div>
      <div class="userPassword">
        <input
          type="password"
          v-model="userPassword"
          placeholder="默认密码：手机号后六位"
        />
        <span class="mark-error">请输入密码</span>
      </div>
      <div class="keepMind">
        <a-checkbox
          class="ignore"
          @change="onChange"
          :defaultChecked="rememberID"
          >记住账号和密码</a-checkbox
        >
      </div>
      <div class="submitBtn">
        <a-button @click="loginHref" type="primary">{{ submitTxt }}</a-button>
      </div>
    </form>
    <a class="ownership">© 2021 版权所有 上海标歆网络科技有限公司</a>
  </div>
</template>
<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      userName: "",
      userPassword: "",
      visible: false,
      rememberID: true,
      submitTxt: "登录",
      loginInfo: {}
    };
  },
  computed: {
    ...mapState(["user", "token", "roleList"])
  },
  methods: {
    ...mapMutations(["setUser", "setToken", "setRoleList"]),
    onChange(e) {
      this.rememberID = e.target.checked;
    },
    loginHref() {
      this.submitTxt = "登录中...";
      // console.log($route.path=""),
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "User/companyLogin";
      axios
        .post(url, {
          phone: this.userName,
          password: this.userPassword
        })
        .then(res => {
          if (res.data.code == "200") {
            window.localStorage.setItem("xnwfPcToken", res.data.data.token);
            //判断是否保存用户名
            if (this.rememberID) {
              window.localStorage.setItem("xnwfPcName", this.userName);
              window.localStorage.setItem("xnwfPcPassword", this.userPassword);
            } else {
              window.localStorage.removeItem("xnwfPcName");
              window.localStorage.removeItem("xnwfPcPassword");
            }
            // this.setUser({
            //   phone: this.userName,
            //   password: this.userPassword
            // });
            // this.setToken(res.data.data.token);
            let roleList = [];
            res.data.data.role_info.forEach(element => {
              roleList.push(element.role_name);
            });
            let type;
            res.data.data.employee_type == 2
              ? (type = "三方公司")
              : (type = "玄鸟内部");
            window.localStorage.setItem("xnserve-authority", roleList);
            window.localStorage.setItem("xnserve-authority-type", type);
            // this.setRoleList(res.data.data.role_info);
            // console.log(res.data.data.employee_type);
            let leg = this.userName.substring(this.userName.length - 6);
            if (leg != this.userPassword) {
              type == "玄鸟内部"
                ? this.$router.push({ name: "home" })
                : this.$router.push({ name: "taskResumeMyCreate" });
              // if (type == "玄鸟内部") {
              //   if (this.userName == "18012344321") {
              //     this.$router.push({ name: "cleanHouse" });
              //   } else {
              //     this.$router.push({ name: "home" });
              //   }
              // } else {
              //   this.$router.push({ name: "taskResumeMyCreate" });
              // }
            } else {
              let _this = this;
              this.$error({
                title: "风险提示",
                content: "使用默认密码账号容易被盗，需及时修改",
                onOk() {
                  _this.$router.push({ name: "password" });
                }
              });
            }

            this.submitTxt = "登录";
          } else {
            this.$message.error(res.data.message);
            this.submitTxt = "登录";
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    }
  },
  mounted() {
    // console.log( this.user)
    if (window.localStorage.getItem("xnwfPcName") != null) {
      this.userName = window.localStorage.getItem("xnwfPcName");
      this.userPassword = window.localStorage.getItem("xnwfPcPassword");
    } else {
      this.userName = "";
      this.userPassword = "";
    }

    if (navigator.userAgent.indexOf("iPhone") !== -1) {
      window.wechaturl = window.location + "";
      // console.log(window.wechaturl);
    } //ios
    if (navigator.userAgent.indexOf("miniProgram") !== -1) {
      window.wechaturl = window.location + "";
    } //android
    // console.log(window.wechaturl);
  },
  components: {}
};
</script>
<style scoped lang="less">
@import url("../../style/login/login.less");
</style>
